import type { TeamOfficeGetResponse } from "@bezoned/shared/types/api/team/team-office-get.types.js";
import { createContext } from "react";

export type OfficeContextType = TeamOfficeGetResponse & {
  __ctx_init: boolean;
};

export const OfficeContext = createContext<OfficeContextType | null>(null);
